// extracted by mini-css-extract-plugin
module.exports = {"selectLabel":"TFBSelect_selectLabel__1gaQV","selectGroup":"TFBSelect_selectGroup__7DgM0"};